<template>
<div id="booking-widget">
   <div class="container bv-example-row content-body">
    <div class="row">
        <div class="col-md-12 col-sm-12 col-12">
          <div class="row" style="margin-bottom:20px;">
            <div class="col-md-4"></div>
             <div class="col-md-4 text-center">
                <img :src="paymentDetails.logo" :alt="paymentDetails.name">
             </div>
              <div class="col-md-4"></div>
          </div>
          <div class="row">
            <div class="col-md-12">
             <div id="placed">
                        <h4>Payment Not Made</h4>
                       <div id="thankyou">
                            Thank you  {{fullName}}.<br>
                        </div>
                        Your reservation at <strong>{{paymentDetails.name}}</strong> has been placed
                        successfully. However, please note that this is not a payment confirmation hence we cannot fully
                        confirm your booking until payment is received.
                    </div>
              <div class="text-center mrgb10">
                <a target="_blank" @click="print"  class="btntop">
                  Print confirmation
                </a>
              </div>
              <div
                class="text-center"
                style="margin: 0 auto; padding-top: 0.3em; padding-bottom: 0.3em"
              >
                <p>Your reservation number is <span>{{referenceNumber}}</span></p>
              </div>
              <p>
                <span
                  class="badge badge-info"
                  style="
                    color: #fff;
                    font-size: 12px;
                    margin: 0 auto;
                    display: table;
                    padding: 0.5em 0.6em 0.3em 0.6em;
                  "
                >
                  Arrival: &nbsp;{{checkinDate}} &nbsp;&nbsp;&nbsp; Departure:
                  &nbsp;{{checkoutDate}}
                </span>
              </p>
            </div>
          </div>

            <div class="row">
            <div class="col-md-12">
              <table
                id="room_details_1"
                class="table table-bordered table-striped"
              >
               <thead>
                  <th>{{roomLabel.singular}} details</th>
                  <th>Nights</th>
                  <th colspan="2">Guests</th>
                  <th style="position: relative">Meal Plan</th>
                  <th style="text-align: right">Total</th>
                </thead>
                  <!-- if multiroom -->
                    <tbody>
                      <tr
                          v-for="(mroom, index) in rooms"
                          :key="index"
                        >
                      <td>{{ mroom.name }}</td>
                      <td>{{night}}</td>
                      <td colspan="2"><span>{{mroom.adults}} adult</span> &nbsp;<span v-if="mroom.children > 0">{{mroom.children}} children</span>&nbsp;<span v-if="mroom.babies > 0">{{mroom.babies}} babies</span></td>
                      <td valign="middle"><span v-if="mroom.meal_plan !=''">{{mroom.meal_plan}}</span> <span v-else>N/A</span></td>
                      <td valign="middle" style="text-align: right">
                        {{paymentDetails.currency}} {{ formatPrice(mroom.price) }}
                      </td>
                    </tr>
                    </tbody>
                  <!-- end -->
              </table>
              <div v-if="enhancements.length !=0">
                 <div class="enh-head">
                <div class="row">
                  <div class="col-md-12">Enhancements</div>
                </div>
              </div>
              <div
                class="row enhancements"
                v-for="(adhance, index) in enhancements"
                :key="index"
              >
                <div class="col-md-6 paddt5 paddb5 paddl5">
                  {{ adhance.name }}
                </div>
                <div class="col-md-3 paddt5 paddb5 text-left">
                  <strong>Qnty:</strong>
                </div>
                <div class="col-md-3 paddt5 paddb5 paddr5 text-right">
                 {{paymentDetails.currency}} {{ formatPrice(adhance.price) }}
                </div>
              </div>
              </div>
              <div class="clear clearfix paddtb5"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-7"></div>
            <div class="col-md-5 paddborder0">
              <div class="block mrgt15">
                <table
                  id="priceSum"
                  class="table table-bordered pull-right mrgb10"
                  style="max-width: 350px"
                >
                  <tbody>
                    <tr>
                      <td class="pricelabel">Subtotal:</td>
                      <td id="finalPrice">
                        <div id="sub-total">{{paymentDetails.currency}} {{formatPrice(paymentDetails.subTotal)}}</div>
                      </td>
                    </tr>
                    <tr v-if="paymentDetails.totalDiscount !=0">
                      <td class="pricelabel">Discount:</td>
                      <td id="finalPrice">
                        <div id="sub-total">{{paymentDetails.currency}} {{formatPrice(paymentDetails.totalDiscount)}}</div>
                      </td>
                    </tr>
                    <tr v-if="paymentDetails.totalServiceCharge > 0">
                      <td class="pricelabel">Service Charges:</td>
                      <td id="finalPrice">
                        <span>{{paymentDetails.currency}} {{formatPrice(paymentDetails.totalServiceCharge)}}</span>
                      </td>
                    </tr>
                    <tr v-if="paymentDetails.totalVAT > 0">
                      <td class="pricelabel">Total VAT ({{formatPrice(vat.value)}} %)</td>
                      <td id="finalPrice">
                        <span>{{paymentDetails.currency}} {{formatPrice(paymentDetails.totalVAT)}} </span>
                      </td>
                    </tr>

                    <tr v-if="paymentDetails.totalHotelTax > 0">
                      <td class="pricelabel">{{hotelTax}}:</td>
                      <td id="finalPrice">
                         {{paymentDetails.currency}} {{formatPrice(paymentDetails.totalHotelTax)}}
                      </td>
                    </tr>
                     <tr v-if="extraCharges.gateway_fee_enabled ==1 && paymentDetails.totalGatewayFee > 0">
                      <td class="pricelabel">Gateway Fee:</td>
                      <td id="finalPrice">
                        <span>{{paymentDetails.currency}} {{formatPrice(paymentDetails.totalGatewayFee)}}</span>
                      </td>
                    </tr>
                    <tr v-if="paymentDetails.offlineSurcharge > 0">
                      <td class="pricelabel">SurCharges Fee:</td>
                      <td id="finalPrice">
                        <span>{{paymentDetails.currency}} {{formatPrice(paymentDetails.offlineSurcharge)}}</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="pricelabel">Total:</td>
                      <td id="finalPrice">
                        <div>
                           <span>{{paymentDetails.currency}} {{formatPrice(paymentDetails.totalAmountPayable)}}</span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="statuslabel">Status</td>
                      <td id="finalPrice">
                        <div>
                          <span class="status status_placed">Unpaid<br><small>- Pay at the property</small></span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="pricelabel">Payment Method:</td>
                      <td id="finalPrice">
                        <div>Pay On Arrival</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="clear clearfix paddtb5"></div>
          </div>
          <hr />
           <div class="row">
             <div class="col-md-6 col-sm-6">
                        <div class="whatnext">
                            <h3>What Next?</h3>
                            <p>Your reservation has been placed successfully. Please note that we cannot fully confirm your booking until payment received.</p>
                        </div>
                    </div>
            <div class="col-md-6 col-sm-6">
              <div
                class="text-center share-complete"
                style="max-width: 350px; margin: 10px auto; display: table"
              >
                <h3>Share this with friends</h3>
                <strong>Let your friends know you made a booking online</strong>
                <div class="icon-share text-center">
                  <a
                    target="_blank"
                    class="fb"
                    v-if="contactDetails.facebookPage !=''"
                    :href="contactDetails.facebookPage"
                  >
                    <i class="fa fa-facebook"></i>
                  </a>
                   <a
                    class="fb"
                    v-else
                    href="javascript:void(0)"
                  >
                    <i class="fa fa-facebook"></i>
                  </a>

                  <a
                    target="_blank"
                    class="tw"
                    v-if="contactDetails.twitterHandle !=''"
                    :href="contactDetails.twitterHandle"
                  >
                    <i class="fa fa-twitter"></i>
                  </a>
                  <a
                    class="tw"
                   v-else
                    href="javascript:void(0)"
                  >
                    <i class="fa fa-twitter"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div v-show="printpage" id="printMe">
         <table style="width:100%; margin:30px 0;">
        <tbody>
            <tr>
                <td style="font-family:Arial,Helvetica,sans-serif;text-align:center;font-size:14px;">
                    <table id="receipt"
                           style="max-width:680px; width: 100%; margin:0 auto; padding:15px 0; border:1px solid #DEDEDE; background:#FFF">
                        <tbody style="font-family:Arial,Helvetica,sans-serif;text-align:left;font-size:14px;">
                          <tr>
                                <td style="font-family:Arial,Helvetica,sans-serif;text-align:center;font-size:14px; padding:15px 0">
                                    <!-- <img :alt="paymentDetails" :title="paymentDetails" :src="paymentDetails.logo"> -->
                                </td>
                            </tr>
                            <tr>
                                <td style="font-family:Arial,Helvetica,sans-serif;text-align:center;font-size:14px;">
                                  <h4><strong>Thank you, your reservation has been confirmed.</strong></h4>
                                  <h4>Your reservation number is <strong>{{referenceNumber}}</strong>
                                    </h4>
                                </td>
                            </tr>
                            <tr>
                              <td style="font-family:Arial,Helvetica,sans-serif;text-align:left; padding:20px;font-size:14px;">
                                    Dear user {{fullName}},<br/><br/>
                                    Thank you for making your reservation at
                                    <strong>{{paymentDetails.name}}</strong>.<br/><br/>
                                    However, please note that we cannot fully confirm your booking until payment has been received. Kindly do contact us should you need further assistance.<br/><br/>
                                    We look forward to welcoming you and wish you a most hospitable stay.<br/><br/>
                              </td>
                            </tr>
                            <tr>
                                <td style="font-family:Arial,Helvetica,sans-serif;text-align:left; padding:0 20px;font-size:14px;">
                                    <table class="table" style="width:100%">
                                        <tbody>
                                        <tr>
                                          <td valign="top" style="padding:0; width: 49%; float:left; border-top: none">
                                                    <table style="width:100%; margin-bottom:15px; border: 1px solid #DEDEDE ">
                                                        <tbody>
                                                            <tr>
                                                                <td colspan="2"
                                                                    style="background:#e5e5e5;padding:3.0pt 10.0pt 3.0pt 10.0pt;">
                                                                    <strong>Payment Details</strong>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style="padding:5pt 10.0pt 0 10.0pt; min-width: 150px; min-width: 150px">
                                                                    <strong>Payment Ref: </strong>
                                                                </td>
                                                                <td style="padding:5pt 10.0pt 5pt 5pt">
                                                                  {{paymentDetails.referenceNumber}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style="padding:5pt 10.0pt 0 10.0pt; min-width: 150px">
                                                                    <strong>Payment Date: </strong>
                                                                </td>
                                                                <td style="padding:5pt 10.0pt 5pt 5pt">
                                                                  {{checkinDate}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style="padding:5pt 10.0pt 0 10.0pt">
                                                                    <strong>Payment Status: </strong>
                                                                </td>
                                                                <td style="padding:5pt 10.0pt 5pt 5pt">
                                                                    <span class="status status_paid">
                                                                      Unpaid
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style="padding:5pt 10.0pt 0 10.0pt">
                                                                    <strong>Payment Method: </strong>
                                                                </td>
                                                                <td style="padding:5pt 10.0pt 5pt 5pt">
                                                                  Pay On Arrival
                                                               </td>
                                                            </tr>
                                                            <tr>
                                                                <td style="padding:5pt 10.0pt 0 10.0pt">
                                                                    <strong>
                                                                        Processed By:                                                                     </strong>
                                                                </td>
                                                                <td style="padding:5pt 10.0pt 5pt 5pt">PesaPal</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <td valign="top" style="padding:0; width:49%; float:right; border-top: none">
                                                <table style="width:100%; border: 1px solid #DEDEDE">
                                                    <tbody>
                                                        <tr>
                                                            <td colspan="2" style="background:#e5e5e5;padding:3.0pt 10.0pt 3.0pt 10.0pt;">
                                                                <strong>Booking Details</strong>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding:5pt 10.0pt 0 10.0pt">
                                                                <strong>Booking Ref: </strong>
                                                            </td>
                                                            <td style="padding:5pt 10.0pt 5pt 5pt;">
                                                              {{paymentDetails.referenceNumber}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="padding:5pt 10.0pt 0 10.0pt">
                                                                <strong>Arrival date: </strong>
                                                            </td>
                                                            <td style="padding:5pt 10.0pt 5pt 5pt;">
                                                              {{checkinDate}}
                                                            </td>
                                                        </tr>
                                                          <tr>
                                                              <td style="padding:5pt 10.0pt 0 10.0pt">
                                                                    <strong>Arrival Time</strong>
                                                                </td>
                                                                <td style="padding:5pt 10.0pt 5pt 5pt;">
                                                                  {{arrivalTime}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                            <td style="padding:5pt 10.0pt 0 10.0pt">
                                                                <strong> Departure date:</strong>
                                                            </td>
                                                            <td style="padding:5pt 10.0pt 5pt 5pt;">
                                                              {{checkoutDate}}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                                <tr>
                                    <td style="font-family:Arial,Helvetica,sans-serif;text-align:left; padding:0 20px;font-size:14px;">
                                        <table id="room_details_1" class="table" style="width:100%; margin-bottom:15px">
                                            <thead>
                                            <th style="background:#e5e5e5; border-bottom:none; padding:3.0pt 10.0pt 3.0pt 10.0pt;">{{roomLabel.singular}} details</th>
                                            <th style="background:#e5e5e5; border-bottom:none; padding:3.0pt 10.0pt 3.0pt 10.0pt;">Nights</th>
                                            <th colspan="2"
                                                style="background:#e5e5e5;  border-bottom:none; padding:3.0pt 10.0pt 3.0pt 10.0pt;">Guests</th>
                                            <th style="background:#e5e5e5;  border-bottom:none; padding:3.0pt 10.0pt 3.0pt 10.0pt;">Meal Plan</th>
                                            <th style="text-align:right; border-bottom:none; background:#e5e5e5;padding:3.0pt 10.0pt 3.0pt 10.0pt;">Total</th>
                                            </thead>
                                            <!-- if multiroom -->
                                             <tbody>
                                                <tr
                                                    v-for="(mroom, index) in rooms"
                                                    :key="index"
                                                  >
                                                <td style="padding:3pt 10.0pt 3pt 10.0pt">{{ mroom.name }}</td>
                                                <td style="padding:3pt 10.0pt 3pt 10.0pt">{{night}}</td>
                                                <td colspan="2"  style="padding:3pt 10.0pt 3pt 10.0pt"><span>{{mroom.adults}} adult</span> &nbsp;<span v-if="mroom.children > 0">{{mroom.children}} children</span>&nbsp;<span v-if="mroom.babies > 0">{{mroom.babies}} babies</span></td>
                                                <td valign="middle" style="padding:3pt 10.0pt 3pt 10.0pt"><span v-if="mroom.meal_plan !=''">{{mroom.meal_plan}}</span> <span v-else>N/A</span></td>
                                                <td valign="middle" style="text-align:right; padding:3pt 10.0pt 3pt 10.0pt">
                                                  {{paymentDetails.currency}} {{ formatPrice(mroom.price) }}
                                                </td>
                                              </tr>
                                              </tbody>
                                            <!-- end -->
                                        </table>
                                    </td>
                                </tr>
                                 <tr>
                                <td style="font-family:Arial,Helvetica,sans-serif;text-align:left; padding:0 20px;font-size:14px;" v-if="enhancements.length != 0">
                                    <table id="room_details_2" class="table" style="width:100%; margin-bottom:15px">
                                        <thead>
                                        <th colspan="3"   style="background:#e5e5e5; border-bottom:none; padding:3.0pt 10.0pt 3.0pt 10.0pt;"> Enhancements</th>
                                        </thead>
                                        <tbody  v-for="(adhance, index) in enhancements" :key="index">
                                              <tr>
                                                <td style="padding:3pt 10.0pt 3pt 10.0pt; border-right:none">{{adhance.name}}</td>
                                                <td style="padding:3pt 10.0pt 3pt 10.0pt; border-right:none">
                                                    <strong>Qnty:</strong>
                                                </td>
                                                <td style="text-align:right; padding:3pt 10.0pt 3pt 10.0pt">
                                                {{paymentDetails.currency}} {{ formatPrice(adhance.price) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                                </tr>
                            <tr>
                                <td style="padding:0 20px;">
                                    <div style="display:block; width:100%; overflow:hidden">
                                        <table id="priceSum" class="table" style="max-width:350px; margin-bottom: 10px; border: 1px solid #DEDEDE; float: right">
                                            <tbody>
                                                <tr>
                                                    <td class="pricelabel" style="background: #eee; font-weight:600; padding:5px; min-width:150px;">
                                                        Subtotal:
                                                    </td>
                                                    <td align="right" style="padding:5px; min-width:150px">
                                                        <div id="sub-total">

                                                           <div id="sub-total">{{paymentDetails.currency}} {{formatPrice(paymentDetails.subTotal)}}</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                    <tr v-if="paymentDetails.totalDiscount !=0">
                                                      <td class="pricelabel"
                                                          style="background: #eee; font-weight:600; padding:5px; min-width:150px;">
                                                          Discount:
                                                      </td>
                                                      <td align="right">
                                                          <span> {{paymentDetails.currency}} {{formatPrice(paymentDetails.totalDiscount)}} </span>
                                                      </td>
                                                    </tr>
                                                    <tr v-if="paymentDetails.totalServiceCharge > 0">
                                                        <td class="pricelabel"
                                                            style="background: #eee; font-weight:600; padding:5px; min-width:150px;">
                                                            Service Charges:
                                                        </td>
                                                        <td align="right">
                                                           <span> {{paymentDetails.currency}}{{ formatPrice(paymentDetails.totalServiceCharge) }} </span>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="paymentDetails.totalVAT > 0">
                                                        <td class="pricelabel"
                                                            style="background: #eee; font-weight:600; padding:5px; min-width:150px;">
                                                            Total VAT ({{formatPrice(vat.value)}} %)
                                                        </td>
                                                        <td align="right" style="padding:5px; min-width:150px">
                                                           <span> {{paymentDetails.currency}} {{formatPrice(paymentDetails.totalVAT)}} </span>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="paymentDetails.totalHotelTax > 0">
                                                        <td class="pricelabel"
                                                            style="background: #eee; font-weight:600; padding:5px; min-width:150px;">
                                                            {{hotelTax}}:
                                                        </td>
                                                        <td align="right">
                                                             {{paymentDetails.currency}} {{formatPrice(paymentDetails.totalHotelTax)}}
                                                        </td>
                                                    </tr>
                                                     <tr v-if="extraCharges.gateway_fee_enabled ==1 && paymentDetails.totalGatewayFee > 0">
                                                        <td class="pricelabel"
                                                            style="background: #eee; font-weight:600; padding:5px; min-width:150px;">
                                                           Gateway Fee:
                                                        </td>
                                                        <td align="right">
                                                            {{paymentDetails.currency}} {{formatPrice(paymentDetails.totalGatewayFee)}}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="paymentDetails.offlineSurcharge > 0">
                                                      <td class="pricelabel"  style="background: #eee; font-weight:600; padding:5px; min-width:150px;">SurCharges Fee:</td>
                                                      <td align="right">
                                                        <span>{{paymentDetails.currency}} {{formatPrice(paymentDetails.offlineSurcharge)}}</span>
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td class="pricelabel" style="background: #eee; font-weight:600; padding:5px; min-width:150px;">
                                                          Total:
                                                      </td>
                                                      <td align="right">
                                                          <div id="finalPrice">
                                                            <span>{{paymentDetails.currency}} {{formatPrice(paymentDetails.totalAmountPayable)}}</span>
                                                          </div>
                                                      </td>
                                                      </tr>
                                              </tbody>
                                        </table>
                                    </div>

                                </td>
                            </tr>

                             <tr v-if="paymentDetails.terms !==''">
                                    <td style="font-family:Arial,Helvetica,sans-serif;text-align:left; padding:0 20px;font-size:14px;">
                                        <table class="table" style="width:100%; padding:3.0pt 10.0pt 3.0pt 0">
                                            <tbody>
                                            <tr>
                                                <td style="background:#e5e5e5;padding:3.0pt 10.0pt 3.0pt 10.0pt">
                                                    <strong>Terms & Conditions</strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding:5pt 10.0pt 5pt 10pt">
                                                    <p v-html="paymentDetails.terms"></p>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                 <tr v-if="paymentDetails.cancellation_policies !==''">
                                    <td style="font-family:Arial,Helvetica,sans-serif;text-align:left; padding:0 20px;font-size:14px;">
                                        <table class="table" style="width:100%; padding:3.0pt 10.0pt 3.0pt 0">
                                            <tbody>
                                            <tr>
                                                <td style="background:#e5e5e5;padding:3.0pt 10.0pt 3.0pt 10.0pt">
                                                    <strong>Cancellation Policies</strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding:5pt 10.0pt 5pt 10pt">
                                                    <p  v-html="paymentDetails.cancellation_policies"></p>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>

                            <tr>
                                <td style="font-family:Arial,Helvetica,sans-serif;text-align:left; padding:0 25px 20px 25px;font-size:14px;">
                                    <strong>Sincerely,<br/></strong>
                                    e-Commerce,<br />
                                    {{paymentDetails.name}}

                                    <br />
                                    <br /><strong>Tel: </strong>{{contactDetails.phoneNumber}}<br /><strong>Email: </strong>{{contactDetails.mainEmail}} /{{contactDetails.alternativeEmail}}<br /> <strong>Website:</strong> {{contactDetails.websiteURL}}
                                </td>
                            </tr>
                            <tr>
                                <td style="font-family:Arial,Helvetica,sans-serif;text-align:left; padding:10px 25px 10px 25px;font-size:14px; border-top: 1px dotted #DEDEDE">
                                    <div style="display: block; text-align: center;">
                                        <strong>Powered by: </strong>
                                        <a href="http://www.reserveport.com" style="color: #df7042; font-size: 12px; display: inline-block;">Reserveport</a> &
                                        <a href="http://www.pesapal.com" style="color: #a81414; font-size: 12px; display: inline-block;"><span style="color: #1e62a6; display: inline-block">Pesa</span>Pal</a><br>
                                        &copy; 2014 - {{currentYear}}, all rights reserved.
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
    </div>
    <!-- kijkm -->
  </div>
</div>
</template>

<script>
import loader from '../components/loader.vue'
import reusableData from '../components/mixins/reusableData'
import moment from 'moment'
export default {
  name: 'App',
  components: {
    'loader-terms': loader
  },
  data () {
    return {
      chargeType: '',
      printpage: false,
      enhancementprice: 0,
      paymentDetails: {},
      propertyid: '', // this.$store.state.pid,
      consumerKey: '',
      night: 0,
      currentYear: '',
      fullName: '',
      occupancy: '',
      enhancements: '',
      vat: '',
      extraCharges: '',
      referenceNumber: '',
      checkinDate: '',
      checkoutDate: '',
      rooms: '',
      hotelTax: '',
      contactDetails: '',
      arrivalTime: '',
      departureTime: '',
      roomLabel: ''
    }
  },
  created () {
    this.getPaymentDetails()
    this.currentYear = moment().format('YYYY')
  },
  methods: {
    print () {
      this.$htmlToPaper('printMe')
    },
    formatPrice (value) {
      if (isNaN(value)) {
        return value
      } else {
        let val = (value / 1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    async getPaymentDetails () {
      var hash = document.location.hash
      var urlparameters = hash.split('?')[1]
      var propid = urlparameters.split('&')[0]
      var urldata = urlparameters.split('&')[1]
      var encryptedData = urldata.split('=')[1]
      var reconstructedData1 = encryptedData.split('%3D')
      var reconstructedData = reconstructedData1.join('=')
      var encodedpid = propid.split('=')[1]
      var reconstructedpid1 = encodedpid.split('%3D')
      var reconstructedpid = reconstructedpid1.join('=')
      this.propertyid = atob(reconstructedpid)
      const configUrl = process.env.CONFIG_URL['live_url']
      const key = process.env.PMS_KEY['key']
      const config = {
        headers: { 'Accept': 'application/json' }
      }
      const payload = {
        'property_id': this.propertyid,
        'api': this.type
      }
      const configRes = await this.$http.post(configUrl, payload, config)
      if (configRes.status === 200) {
        let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
        configData = JSON.parse(configData)
        const passkey = configData[0].val_ptoken// process.env.SECRET_KEY[this.propertyid].key
        let consumerKey = configData[0].val_reserveport_secret_key// process.env.CONSUMER_KEY[this.propertyid].key
        const details = JSON.parse(configData[0].add_details)
        var decryptedurlparamData = this.CryptoJSAesDecrypt(passkey, atob(reconstructedData))
        var jsonparseDecryptedData = JSON.parse(decryptedurlparamData)
        this.referenceNumber = jsonparseDecryptedData.reference
        const postData = {
          reference_number: this.referenceNumber
        }
        var postDataJson = JSON.stringify(postData)
        var encryptedPostData = this.CryptoJSAesEncrypt(passkey, postDataJson)
        let fetchUrl = details.url
        var url = `${fetchUrl}/index.php?option=com_goreserva_psearch&task=api.fetchReservation&pid=' + this.propertyid + '&consumer_key=${consumerKey}&data=${encryptedPostData}`
        this.axios
          .get(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then((response) => {
            var responseData = response.data.er
            var decryptedData = this.CryptoJSAesDecrypt(passkey, responseData)
            return JSON.parse(decryptedData)
          })
          .then((data) => {
            if (data.hasOwnProperty('error') !== false) {
              this.errormsg = data.msg
            } else {
              this.paymentDetails = data
              this.roomLabel = data.room_label
              this.fullName = data.reservationFor.first_name + ' ' + data.reservationFor.last_name
              this.occupancy = data.occupancy
              this.enhancements = data.enhancements
              this.checkinDate = data.occupancy.checkin_date
              this.checkoutDate = data.occupancy.checkout_date
              this.arrivalTime = data.occupancy.arrival_time
              this.departureTime = data.occupancy.departure_time
              this.vat = data.vat
              this.hotelTax = data.extra_charges.hotel_tax.name
              this.extraCharges = data.extra_charges
              this.contactDetails = data.contactDetails
              this.rooms = data.rooms
              var date1 = new Date(this.paymentDetails.occupancy.checkin_date)
              var date2 = new Date(this.paymentDetails.occupancy.checkout_date)
              var DifferenceInTime = date2.getTime() - date1.getTime()
              this.night = DifferenceInTime / (1000 * 3600 * 24)
            }
          })
          .catch((error) => {
            console.log('error', error)
            this.isProcessing = false
          })
      }
      // var baseUrl = process.env.API_URL[this.propertyid].url
    }
  },
  mixins: [reusableData]
}
</script>

<style scoped>
#booking-widget #placed {
    background: #d9edf7;
    border: 1px solid #bce8f1;
    color: #31708f;
    margin-top: 0;
    margin-bottom: 10px;
    padding: 10px;
}
#booking-widget #thankyou {
    display: block;
    margin-bottom: 10px;
    font-weight: 600;
}
#booking-widget .btn-large {
    width: 100%;
    max-width: 350px;
    font-size: 17px;
    margin-top: 10px;
    margin-bottom: 10px;
}
#booking-widget .btnb {
    text-transform: uppercase;
    font-weight: 500;
    font-size: 12px!important;
    padding: 6px 10px 5px 10px!important;
    background: #D65A29;
    border-color: #D65A29;
    color: #FFF;
    overflow: hidden;
    -moz-border-radius: 0px!important;
    -webkit-border-radius: 0px!important;
    -khtml-border-radius: 0px!important;
    border-radius: 0px!important;
    border-top-left-radius: 0px!important;
    border-top-right-radius: 0px!important;
    border-bottom-right-radius: 0px!important;
    border-bottom-left-radius: 0px!important;
}
#booking-widget h1, #booking-widget .h1, #booking-widget h2, #booking-widget .h2, #booking-widget h3, #booking-widget .h3 {
    margin: 10px 0 10px 0;
    color: #333;
    font-weight: 300;
}
#finalPrice {
  text-align: right;
}
#booking-widget .btntop {
  border: none;
  padding: 6px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  border-radius: 4px;
  cursor: pointer;
  background: #28a745;
}
#booking-widget .btntop:hover{
  background: #D65A29;
}
#booking-widget .mrgb10 a {
  color: white;
}
#booking-widget .icon-share a.fb {
  background: #2954a3;
  color: #fff;
}
#booking-widget .icon-share a.tw {
  background: #1db4c6;
  color: #fff;
}
#booking-widget .icon-share a {
  display: inline-block;
  padding: 8px 5px;
  margin: 0 0 0 5px;
  min-width: 32px;
  text-align: center;
}
#booking-widget .block,
#booking-widget .btn-book {
  display: block;
  overflow: hidden;
}

#booking-widget .mrgt15 {
  margin-top: 15px;
}

#booking-widget #priceSum tr,
#booking-widget #priceSum td {
  padding-top: 5px;
  padding-bottom: 5px;
}
#booking-widget .pricelabel {
  text-align: left !important;
  font-size: 10px;
  text-transform: uppercase;
  white-space: nowrap;
  font-weight: 600;
}
#booking-widget .table td.pricelabel,
#booking-widget .table td.statuslabel {
  text-align: right !important;
  font-size: 10px;
  text-transform: uppercase;
  background: #eee;
  white-space: nowrap;
  font-weight: 600;
}

#booking-widget .enhancements {
  border: 1px solid #dcdcdc;
  border-top: none;
  margin: 0;
  position: relative;
  overflow: hidden;
  padding-bottom: 15px;
}

#booking-widget .enh-head,
#booking-widget .summary-head {
  background: #e9e9e9;
  color: #000;
  font-weight: bold;
  padding: 5px;
  border: 1px solid #dcdcdc;
}

#booking-widget .table th {
  border-bottom: 1px solid #dcdcdc;
  border-left: 0px solid #dcdcdc !important;
  border-right: 0px solid #dcdcdc !important;
  background: #e9e9e9;
  padding: 5px;
}

#booking-widget .table td {
  border-bottom: 1px solid #dcdcdc;
  background: #F9F9F9;
  border-left: 0px solid #dcdcdc !important;
  border-right: 0px solid #dcdcdc !important;
}

#booking-widget .content-body {
  margin-top: 5em;
  margin-bottom: 5em;
  font-size: 0.9em !important;
}
.slide-fade-enter-active {
  transition: all 0.1s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/offlinePayment.vue